import TotalCollection_MonthWise from '../../../../assets/images/TotalCollection(MonthWise).png';
import { Chart } from "react-google-charts";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { managementFinanceAPI } from '../../../../api/managementFinanceAPI';
import { toast } from 'react-toastify';
import AllPcode from '../../../allPcode';
import usePcode from '../../../../common/hooks/usePcode';

const options = {
    colors: ['#0000cc', '#990000'],
    title: "Total Collection (Month Wise)",
    fontSize: 15,
    hAxis: {
        title: 'Month',
        titleTextStyle: {
            color: '#333',
            bold: true,
            fontSize: 15
        },
        textStyle: {
            color: '#333'
        },
    },
    vAxis: {
        title: 'Net Total (LKR)',
        ticks: { stepSize: 50000 },
        titleTextStyle: {
            color: '#333',
            bold: true,
            fontSize: 15
        },
        textStyle: {
            color: '#333'
        },
        baselineColor: "#000000"
    },
    series: {
        0: { color: '#ff0000' },
        1: { color: '#0000ff' },
    },
    legend: 'right', chartArea: { width: "50%" },

};

export default function TotalCollection_MonthWiseModal() {
    const [totalCollection, setTotalCollection] = useState([]);
    const [selectedYear, setSelectedYear] = useState(dayjs());
    const [showChart, setShowChart] = useState(false);
    const [chartData, setChartData] = useState([]);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);


    useEffect(() => {
        if (!selectedYear) { toast.warn("Please select a year"); return; }
        const currentYear = selectedYear.year().toString();
        const previousYear = (selectedYear.year() - 1).toString();

        const totalCollectionChart = [['Month', `${currentYear}`, `${previousYear}`]];

        for (let i = 1; i <= 12; i++) {
            const currentYearItem = totalCollection.find(item => item.year === currentYear && parseInt(item.month) === i);
            const previousYearItem = totalCollection.find(item => item.year === previousYear && parseInt(item.month) === i);

            const monthName = new Date(currentYear, i - 1, 1).toLocaleString('default', { month: 'short' });
            const currentYearCount = currentYearItem ? parseFloat(currentYearItem.totalCollectionCount) : 0;
            const previousYearCount = previousYearItem ? parseFloat(previousYearItem.totalCollectionCount) : 0;

            totalCollectionChart.push([monthName, currentYearCount, previousYearCount]);
        }
        setChartData(totalCollectionChart);

    }, [selectedYear, totalCollection]);

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("TotalCollection");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    useEffect(() => {
        handleTotalCollection(selectedPcode, selectedYear);
    }, [selectedPcode, selectedYear]);

    const handleTotalCollection = (selectedPcode, selectedYear) => {
        if (!selectedYear) { toast.warn("Please select a year"); return; }
        const year = selectedYear.year();
        managementFinanceAPI.getTotalCollections(year, selectedPcode).then((data) => {
            setTotalCollection(data);
        }).catch((err) => {
            toast.error(err.message);
        });
    }

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#TotalCollection">
                <img src={TotalCollection_MonthWise} class="card-img-top rounded rounded-5" alt="TotalCollection" />
            </a>
            <div className="modal fade" id="TotalCollection" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Total Collection (Month Wise)</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-8 col-xl-8 col-xxl-8">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                                    <div className="input-group input-group-sm">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker views={['year']}
                                                value={selectedYear}
                                                onChange={handleYearChange}
                                                slotProps={{
                                                    textField: {
                                                        className: 'custom-datepicker',
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </div>
                                {showChart ? (
                                    totalCollection.length > 0 ? (
                                        <Chart
                                            chartType="LineChart"
                                            style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                                            data={chartData}
                                            options={options}
                                        />
                                    ) : (
                                        <h3>No Data Available</h3>
                                    )
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}